/**
 * 车辆载重动态报表eCharts配置
 * @param data
 * @returns {{title: {text: string, textStyle: {fontWeight: string, fontSize: number}, left: string, top: string}, color: string[], legend: {orient: string, x: string, y: string, bottom: number, padding: number[], selected: {温度: boolean, 湿度: boolean, 温度1: boolean, 湿度1: boolean, 温度2: boolean, 湿度2: boolean, 温度3: boolean, 湿度3: boolean, 温度4: boolean, 湿度4: boolean, 温度要求: boolean, 湿度要求: boolean}, data: Array}, tooltip: {trigger: string, axisPointer: {lineStyle: {color: string}}, formatter: (function(*): string)}, grid: {left: string, right: string, bottom: string, containLabel: boolean}, xAxis: {type: string, boundaryGap: boolean, name: string, nameTextStyle: {color: string}, nameGap: number, axisLine: {lineStyle: {color: string}}, nameLocation: string, splitLine: {show: boolean, lineStyle: {color: string[], width: number, type: string}}, axisLabel: {color: string, padding: number[]}, data: Array}, yAxis: *[], series: Array}}
 */
// 条形折线图
const getBarLineOpt = (data) => {
    let rData = data;
    let xCategories = [];
    let inWData1 = []; //载重数据
    let tonnageData  = []; //空车质量
    rData.forEach(node => {
        xCategories.push(node.gpsTime);
        inWData1.push(node.totalMass);
        tonnageData.push(node.tonnage);
    });
    let legendList, colorList;

        legendList = [
            "总质量",
            "空车质量"
        ];
        colorList = [
            "#5CB0EF",
            "#339900"
        ];
    //获取Legend数据
    const getLegendData = () => {
        let arr = [];
        legendList.forEach(item => {
            arr.push({
                name: item,
                textStyle: {
                    fontSize: 12,
                    fontWeight: "normal",
                    fontStyle: "normal",
                    color: "#909399"
                },
                icon: getSymnolState(item).icon
            });
        });
        return arr;
    };
    //获取series数据
    const getSeriesData = () => {
        let arr = [];
        legendList.forEach(item => {
            arr.push({
                name: item,
                type: "line",
                itemStyle: {
                    normal: {
                        lineStyle: {
                            width: getSymnolState(item).lineWidth,
                            type: getSymnolState(item).lineType
                        }
                    }
                },
                //yAxisIndex: item.startsWith("湿度") ? 1 : 0,
                //symbol: getSymnolState(item).symnolType,
                smooth: true, //这句就是让曲线变平滑的
                data: initData(item)
            });
        });

        return arr;
    };
    //获取不同类型的状态
    const getSymnolState = item => {
        let obj = {};

        if (item == "空车质量" ) {
            obj.lineType = "dashed";
            obj.lineWidth = "2";
            obj.symnolType = "roundRect";
            obj.icon = "line";
        } else {
            obj.lineType = "solid";
            obj.lineWidth = "2";
            obj.symnolType = "";
            obj.icon = "";
        }
        return obj;
    };
    //初始化不同类型的数据
    const initData = item => {
        let data = null;
        switch (item) {
            case "总质量":
                data = inWData1;
                break;
            case "空车质量":
                data = tonnageData;
                break;

            default:
        }
        return data;
    };
    let objData = {
        title: {
            text: "",
            textStyle: {
                fontWeight: "normal",
                fontSize: 12
            },
            left: "60",
            top: "20"
        },
        color: colorList,
        legend: {
            orient: "horizontal",
            x: "center",
            y: "93%",
            bottom: 20,
            padding: [5, 0],
            selected: {
                总质量: true,
                空车质量: true,

            },
            data: getLegendData()
        },
        tooltip: {
            trigger: "axis",
            axisPointer: {
                lineStyle: {
                    color: "#e6ebf2"
                }
            },
            formatter: function (data) {
                let proportion = "时间：" + data[0].name + "</br>";
                let inWData = ""; //载重

                data.forEach(item => {
                    //判断
                    switch (item.seriesName) {
                        case "总质量":
                        case "空车质量":
                            inWData +=
                                item.seriesName +
                                "：" +
                                (item.value === "" ||
                                item.value === null ||
                                item.value === undefined
                                    ? "--"
                                    : item.value + "kg") +
                                "</br>";
                            break;

                        default:
                    }
                });
                if(data[0].value&&data[1].value){
                    inWData+="载重："+(data[0].value - data[1].value)+"kg";
                }
                return (
                    proportion +
                    inWData
                );
            }
        },
        grid: {
            left: "5%",
            right: "8%",
            bottom: "8%",
            containLabel: true
        },
        xAxis: {
            type: "category",
            boundaryGap: false,
            name: "",
            nameTextStyle: {
                color: "#606266"
            },
            nameGap: 25,
            axisLine: {
                lineStyle: {
                    color: "#e6ebf2"
                }
            },
            nameLocation: "start",
            splitLine: {
                show: true,
                lineStyle: {
                    color: ["#e6ebf2"],
                    width: 1,
                    type: "solid"
                }
            },
            axisLabel: {
                color: "#606266",
                padding: [0, 0, 0, 10]
            },
            data: xCategories
        },
        yAxis: [
            {
                name: "总质量(kg)",
                nameTextStyle: {
                    color: "#606266"
                },
                type: "value",
                axisLabel: {
                    color: "#606266",
                    formatter: "{value}"
                },
                axisLine: {
                    lineStyle: {
                        color: "#e6ebf2"
                    }
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: ["#e6ebf2"],
                        width: 1,
                        type: "solid"
                    }
                },
                splitArea: {
                    show: true,
                    areaStyle: {
                        color: ["#fafbfc", "#fff"]
                    }
                }
            },

        ],
        series: getSeriesData()
    };
    return objData;
};

export {getBarLineOpt};
